const NumberService = {
    formatSum : (amount) => {
        if (amount === null || amount === undefined) {
            return "0";
        }
        const normalizedAmount = typeof amount === "string" ? amount : String(amount);
        const splitAmount = normalizedAmount.split('.');
        let iterator = BigInt(splitAmount[0]);
        const isNegative = iterator < 0;
        if(isNegative) {
            iterator = -iterator;
        }
        const decimal = splitAmount.length > 1 ? splitAmount[1] : "";
        let text = "";
        // let iterator = Math.floor(Math.abs(sum));
        // const decimal = Math.abs(sum) - iterator;
        if(decimal > 0) {
            text = text + "." + decimal.slice(0, 2);
        }
        while(iterator > 1000) {
            const mod =  (iterator % 1000n);
            text = (iterator > 1000 ? " " : "") + (mod < 10 ? "00" + mod : mod < 100 ? "0" + mod : mod) + text;
            iterator = iterator / 1000n;
        }
        return (isNegative ? "-" : "") + iterator + text;
    },
    splitNumbers: (str) => {
        return str.split(',')
            .map(item => item.trim()) // Remove whitespace
            .filter(item => item !== '') // Remove empty items
            .map(Number); // Convert to numbers
    },
    getPositiveNumberStr: (str) => {
        const num = parseInt(str, 10);
        if (!isNaN(num) && num > 0) {
            return "" + num;
        } else if (str === "") {
            return "";
        } else {
            return "1";
        }
    }
}

export default NumberService